module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_jssr_1_02-4b1590bbed4c649f3fb6fba828b0c884.png";